import React from 'react';

import TeamSection from '../../components/TeamSection';
import { getAllGameMasters } from '../../lib/sanity';

function GameMasters() {
  return (
    <TeamSection
      titlePlain="Meet Our"
      titleAccent="Game Masters"
      subtitle="The people who bring our board games to life in every workshop."
      fetchMembers={getAllGameMasters}
      loadingLabel="Loading game masters..."
      emptyMessage="Our game master profiles are coming soon."
    />
  );
}

export default GameMasters;
